// src/helpers/api.js
import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE || "https://backdanlu.eu-4.evennode.com";

/* =========================
   CONFIG GLOBAL (afecta a axios por default)
   ========================= */
axios.defaults.baseURL = API_BASE;
// ⚠️ Clave para evitar tu error CORS: NO enviar cookies entre dominios
axios.defaults.withCredentials = false;

// Interceptor GLOBAL para token (aplica a axios y a instancias)
axios.interceptors.request.use((config) => {
  const tk =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("jwt");

  if (tk) {
    // Tu backend lee 'token', dejamos este header
    config.headers.token = tk;

    // Si NO usás Bearer en el backend, podés comentar la siguiente línea
    config.headers.Authorization = `Bearer ${tk}`;
  } else {
    delete config.headers.token;
    delete config.headers.Authorization;
  }

  // Por prolijidad: Content-Type para no-GET si no está seteado
  if (!config.headers["Content-Type"] && config.method !== "get") {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

/* =========================
   Instancia opcional (para nuevos helpers)
   ========================= */
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
  timeout: 30000,
});

// Re-usa el mismo interceptor en la instancia
api.interceptors.request.use((config) => axios.interceptors.request.handlers[0].fulfilled(config));

export default api;
export { axios }; // por si querés importar axios desde acá
